import { createSelector, createFeatureSelector } from '@ngrx/store';
import { SalesPartnersState } from './sales-partners.reducer';

export const selectSalesPartnerState = createFeatureSelector<SalesPartnersState>('salesPartners');

export const selectFetchedSalesPartners = createSelector(selectSalesPartnerState, (state: SalesPartnersState) => state.fetchedSalesPartners);
